import { Drawer, Tabs } from "@caprikorn/dynamo-ui";
import { type FC, useId, useState } from "react";

import { useCustomTranslation } from "@utils/translations/useCustomTranslation";

import { BillConsolidationForm } from "./BillConsolidationForm/BillConsolidationForm";
import { PointOfDeliveryForm } from "./PointOfDeliveryForm/PointOfDeliveryForm";
import type { LevelTypes, SearchDrawerProps } from "./SearchDrawer.types";

export const SearchDrawer: FC<SearchDrawerProps> = ({ onClose }) => {
  const [activeForm, setActiveForm] = useState<LevelTypes>("billConsolidation");
  const { t } = useCustomTranslation(["main", "common"]);
  const formId = useId();

  return (
    <Drawer onClose={onClose} size="lg">
      <Drawer.Header title={t("searchDrawer.title")} />
      <Drawer.Body>
        <Tabs
          hasNoBorder
          onChange={(value) => setActiveForm(value as LevelTypes)}
          value={activeForm}
        >
          <Tabs.Tab
            label={t("searchDrawer.tab.billConsolidation")}
            value="billConsolidation"
          />
          <Tabs.Tab
            label={t("searchDrawer.tab.pointOfDelivery")}
            value="pointOfDelivery"
          />
        </Tabs>
        {activeForm === "pointOfDelivery" && (
          <PointOfDeliveryForm formId={formId} toggleDrawer={onClose} />
        )}
        {activeForm === "billConsolidation" && (
          <BillConsolidationForm formId={formId} toggleDrawer={onClose} />
        )}
      </Drawer.Body>
      <Drawer.Footer>
        <Drawer.Footer.ConfirmButton form={formId} type="submit">
          {t("button.search", { ns: "common" })}
        </Drawer.Footer.ConfirmButton>
      </Drawer.Footer>
    </Drawer>
  );
};
